import React from "react";
import { Query, ApolloConsumer } from "react-apollo";
import gql from "graphql-tag";
import { Waypoint } from "react-waypoint";
import SearchBar from "../../components/SearchBar";

const GET_POSTS = gql`
  query GET_POSTS(
    $limit: Int
    $postType: PostType
    $after: String
    $search: String
  ) {
    posts(limit: $limit, postType: $postType, after: $after, search: $search) {
      id
      title
      slug
      createdBy
      postType
      active
      isPublic
    }
    viewer {
      id
      isUserAuthenticated
    }
  }
`;

class ViewPosts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      filter: null,
    };
    this.typingTimer;
    this.doneTypingInterval = 300;
  }

  onClickPost = async (post) => {
    try {
      const { data } = await this.props.canAccessPost(post.id);

      if (data && data.post.canAccessPost.value) {
        switch (post.postType) {
          case "ARTICLE":
            return this.props.history.push(`/articles/${post.id}/edit`);

          case "NEWS":
            return this.props.history.push(`/newsletters/${post.id}/edit`);

          default:
            return;
        }
      } else {
        alert(data.post.canAccessPost.message);
      }
    } catch (err) {
      console.log("DOES NOT WORK: ", err);
    }
  };

  renderTableRows = (posts) => {
    if (posts.length > 0) {
      return posts.map((post, i) => {
        return (
          <tr
            key={i}
            className="post-link-row"
            onClick={() => this.onClickPost(post)}
            data-cy="post-link-row"
          >
            <td
              dangerouslySetInnerHTML={{ __html: post.title }}
              data-cy="post-title"
            ></td>
            <td data-cy="post-slug">{post.slug && post.slug[0]}</td>
            <td
              dangerouslySetInnerHTML={{ __html: post.createdBy }}
              data-cy="post-created-by"
            ></td>
            <td data-cy="post-type">{post.postType}</td>
            <td data-cy="post-active">{post.active ? "True" : "False"}</td>
            <td data-cy="post-public">{post.isPublic ? "True" : "False"}</td>
          </tr>
        );
      });
    } else {
      return;
    }
  };

  moreOnScroll = (data, fetchMore) => {
    return fetchMore({
      variables: {
        after: data.posts && data.posts[data.posts.length - 1].id,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          posts: [...(prev.posts || []), ...(fetchMoreResult.posts || [])],
        });
      },
    });
  };

  loadMoreOnScroll = (data, fetchMore) => {
    this.moreOnScroll(data, fetchMore).catch(console.log);
  };

  onFinishedTyping = (searchText) => {
    this.setState({ search: searchText });
  };

  onSearch = (e) => {
    e.persist();
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(
      () => this.onFinishedTyping(e.target.value),
      this.doneTypingInterval
    );
  };

  render() {
    return (
      <div>
        <h3>Posts</h3>
        <SearchBar
          placeholder="Search"
          classes={["border", "rounded"]}
          onKeyUp={this.onSearch}
        />
        <Query
          query={GET_POSTS}
          variables={{ search: this.state.search }}
          fetchPolicy="network-only"
        >
          {({ loading, error, data, fetchMore }) => {
            if (loading) return "Loading...";
            if (error) return `Error! ${error.message}`;
            return (
              <div>
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th>Title</th>
                      <th>Slug</th>
                      <th>Created By</th>
                      <th>Type</th>
                      <th>Active</th>
                      <th>Public</th>
                    </tr>
                    {!loading && this.renderTableRows(data.posts)}
                  </tbody>
                </table>
                {!loading && (
                  <Waypoint
                    onEnter={() => this.loadMoreOnScroll(data, fetchMore)}
                  />
                )}
              </div>
            );
          }}
        </Query>
      </div>
    );
  }
}

const CAN_VIEW_POST = gql`
  query post($post_id: String!) {
    post(id: $post_id) {
      canAccessPost(update: false)
    }
  }
`;

const ViewPostsWithLockout = (props) => {
  return (
    <ApolloConsumer>
      {(client) => {
        const viewPostLockout = (post_id) => {
          return client.query({
            query: CAN_VIEW_POST,
            variables: { post_id },
            fetchPolicy: "network-only",
          });
        };

        return <ViewPosts {...props} canAccessPost={viewPostLockout} />;
      }}
    </ApolloConsumer>
  );
};

export default ViewPostsWithLockout;
